export const addChosenPlace = (chosenPlace) => {
  return {
    type: "ADD_CHOSEN_PLACE",
    payload: chosenPlace,
  };
};
export const addAddressLatLng = (addressLatLng) => {
  return {
    type: "ADD_ADDRESS_LAT_LNG",
    payload: addressLatLng,
  };
};

export const addPopupLatLng = (popupLatLng) => {
  return {
    type: "ADD_POPUP_LAT_LNG",
    payload: popupLatLng,
  };
};
